import { Box, Flex, Heading, Input, Button } from '@chakra-ui/react';
import { Link } from 'react-router-dom';

const SignupPage = () => {
  return (
    <Flex
      minH={'100vh'}
      align={'center'}
      justify={'center'}
      bgGradient="linear-gradient(to top, #0c3483 0%, #a2b6df 100%, #6b8cce 100%, #a2b6df 100%)"
    >
      <Box
        rounded={'lg'}
        bg={'white'}
        boxShadow={'lg'}
        p={8}
        maxW={'md'}
        w={'full'}
        color="black" // Set text color to black
      >
        <Heading fontSize={'2xl'} textAlign={'center'} mb={5}>
          Sign Up
        </Heading>
        <Box>
          <Input
            color="black" // Set input text color to black
            placeholder="Username"
            mb={3}
            border="2px solid"
            _placeholder={{ color: 'gray.400' }} // Placeholder color
          />
          <Input
            color="black" // Set input text color to black
            placeholder="Email"
            mb={3}
            _placeholder={{ color: 'gray.400' }}
            border="2px solid"
             // Placeholder color
          />
          <Input
            color="black" // Set input text color to black
            placeholder="Password"
            mb={6}
            type="password"
            _placeholder={{ color: 'gray.400' }}
            border="2px solid"
             // Placeholder color
          />
          <Button colorScheme="blue" size="md" w="full">
            Sign Up
          </Button>
          <Box mt={4} textAlign="center">
            <Link to="/PhoneLoginPage">Already have an account? Log In</Link>
          </Box>
        </Box>
      </Box>
    </Flex>
  );
};

export default SignupPage;
